define('OutSystems/ClientRuntime/modules/MappingWithDefault/MappingWithDefaultService',["require", "exports", "../../Logger"], function (require, exports, Logger) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var MAPPING_WITH_DEFAULT_MODULE_NAME = "MappingWithDefaultService";
    var MappingWithDefaultService = (function () {
        function MappingWithDefaultService() {
            this.messages = {};
        }
        MappingWithDefaultService.prototype.getMessage = function (key, defaultMessage) {
            Logger.trace(MAPPING_WITH_DEFAULT_MODULE_NAME, "Getting message for key " + key + " with default message " + defaultMessage);
            var msg = this.messages[key];
            return msg === undefined || msg === null ? defaultMessage : msg;
        };
        MappingWithDefaultService.prototype.setMessage = function (key, value) {
            Logger.trace(MAPPING_WITH_DEFAULT_MODULE_NAME, "Setting message for key " + key + " with value " + value);
            this.messages[key] = value;
        };
        MappingWithDefaultService.prototype.add = function (messages) {
            var _this = this;
            if (!messages) {
                throw new Error("Messages cannot either null or undefined");
            }
            var messagesKeys = Object.keys(messages);
            Logger.trace(MAPPING_WITH_DEFAULT_MODULE_NAME, "Adding " + messagesKeys.length + " messages");
            messagesKeys.forEach(function (key) { return _this.setMessage(key, messages[key]); });
        };
        MappingWithDefaultService.prototype.clear = function () {
            Logger.trace(MAPPING_WITH_DEFAULT_MODULE_NAME, "Clearing cached messages");
            this.messages = {};
        };
        return MappingWithDefaultService;
    }());
    exports.default = MappingWithDefaultService;
});
//# sourceMappingURL=MappingWithDefaultService.js.map;
